import React, { lazy, Suspense } from "react";

import { Redirect, Route, Switch, useLocation, BrowserRouter } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PublicRoute from "./PublicRoute";
import PageLoader from "@/components/PageLoader";

import Home from '../components/UserView/Home/home';
import Signup from '../components/UserView/Login/register';

// import { Route, BrowserRouter } from 'react-router-dom';
import UserLogin from "../components/UserView/Login/login";
import UserDashboard from "../components/UserView/Dashboard/dashboard";
//import UserRegister from "../components/UserView/Login/register";
import Howitworks from "../components/UserView/Howitworks/howitworks";
import Aboutus from "../components/UserView/Aboutus/aboutus";
import UpdateProfile from "@/components/UserView/Update Profile/updateprofile";
import RequestHistory from "@/components/UserView/Request a listing/requestHistory";
import Notification from "@/components/UserView/Notifications/notification";
import Email from "@/components/UserView/Email/email";
import EmailTwo from "@/components/UserView/Email/emailTwo";
import RequestBusinessHistory from "@/components/UserView/RequestBusinessHistory/RequestBusinessHistory";
import Terms from "@/components/UserView/pages/terms";
import Privacy from "@/components/UserView/pages/privacy";
import CaseSensitiveRoute from "./CaseSensitiveRoute";
//import Changepassword from "@/pages/Admin/Changepassword";

const Changepassword = lazy(() =>
  import(/*webpackChunkName:'Changepassword'*/ "@/pages/Admin/ChangePassword")
);

const ResetPassword = lazy(() =>
  import(/*webpackChunkName:'ResetPassword'*/ "@/pages/Admin/ResetPassword")
);

const Login = lazy(() =>
  import(/*webpackChunkName:'LoginPage'*/ "../pages/Login")
);

const NotFound = lazy(() =>
  import(/*webpackChunkName:'NotFoundPage'*/ "@/pages/NotFound")
);
const UserRegister = lazy(() =>
  import(/*webpackChunkName:'ProductPage'*/ "@/pages/User/UserRegister")
);

export default function AuthRouter() {
  
  const location = useLocation();
 
  return (
    <>
      {/* <BrowserRouter>
				<Route path="/user-login" exact component={UserLogin} />
				<Route path="/user-register" exact component={Signup} />
				<Route path="/user" exact component={Home} />
        <Route path="/user-dashboard" exact component={Dashboard} />
		</BrowserRouter> */}
      <Suspense fallback={<PageLoader />}>
        <AnimatePresence exitBeforeEnter initial={false}>
          <Switch location={location} key={location.pathname}>
            {/* <PublicRoute
            path="/"
            component={Login}
            render={() => <Redirect to="/login" />}
          /> */}
            <Route path="/login" exact component={UserLogin} />
            <Route path="/register" exact component={Signup} />
            <Route path="/" exact component={Home} />
            <Route path="/admin/admin-panel/change-password" exact component={Changepassword} />
            <Route path="/ResetPassword" exact component={ResetPassword} />
            <Route path="/dashboard" exact component={UserDashboard} />
            <Route path="/updateprofile" exact component={UpdateProfile} />
            <Route path="/requesthistory" exact component={RequestHistory} />
            <Route path="/notification" exact component={Notification}/>
            <Route path="/requestbusinesshistory" exact component={RequestBusinessHistory}/>
            
            <CaseSensitiveRoute exact path="/admin/login" component={Login} />
            {/* <Route component={Login} path="/admin/login" exact /> */}

            <Route component={Aboutus} path="/aboutus" exact/>
          <Route component={Terms} path="/terms-and-conditions" exact/>
          <Route component={Privacy} path="/privacy-policy" exact/>
          <Route component={Email} path="/email/:id" exact/>
          <Route component={Email} path="/email/:id" exact/>
          <Route component={EmailTwo} path="/emailTwo/:id" exact/>

            {/* <PublicRoute component={UserRegister} path="/user-register" exact/> */}
            <Route
              path=""
              component={NotFound}
              render={() => <Redirect to="/notfound" />}
            />

           <Route
              path="/verify-email?token"
              component={Email}
              render={() => <Redirect to="/email" />}
            />

          </Switch>
        </AnimatePresence>
      </Suspense>
    </>
  );
}
